import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadUser, WriteUser, CreateUser, UpdateUser } from "@/types/user";

export const UsersService = new APIService<ReadUser, WriteUser>(API.Users);

export const fetchUser = UsersService.get;
export const fetchUserList = UsersService.getList;
export const createUser = UsersService.post<CreateUser, ReadUser>;
export const updateUser = UsersService.patch<UpdateUser, ReadUser>;
export const activateUser = (id: string) =>
  UsersService.patch(id, {}, "activate");
export const deactivateUser = (id: string) =>
  UsersService.patch(id, {}, "deactivate");
export const resetUserPassword = (id: string) =>
  UsersService.post({}, `${id}/reset-password`);
